import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";

type Props = {
  children?: React.ReactNode;
  textAlign?: "left" | "center" | "right";
};

export const ErrorWords = ({ children, textAlign = "center" }: Props) => {
  const box = css({
    width: "640px",
    minHeight: "80px",
    padding: "40px 32px",
    border: `1px solid ${color.iron}`,
    borderRadius: "4px",
    textAlign,
  });

  return (
    <div css={container}>
      <div css={box}>
        <Font variant="m">{children}</Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});
